import { render, staticRenderFns } from "./InitTeam.vue?vue&type=template&id=2042c7d2&scoped=true&"
import script from "./InitTeam.vue?vue&type=script&lang=js&"
export * from "./InitTeam.vue?vue&type=script&lang=js&"
import style0 from "./InitTeam.vue?vue&type=style&index=0&id=2042c7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042c7d2",
  null
  
)

export default component.exports